import { quickLinks } from "../../../mocks/homeData";

const accentMap: Record<string, string> = {
  primary: { bar: "bg-primary-500", icon: "bg-primary-100 text-primary-700", btn: "text-primary-700 hover:bg-primary-50" },
  secondary: { bar: "bg-secondary-500", icon: "bg-secondary-100 text-secondary-900", btn: "text-secondary-800 hover:bg-secondary-50" },
  accent: { bar: "bg-accent-500", icon: "bg-accent-100 text-accent-900", btn: "text-accent-700 hover:bg-accent-50" },
};

export default function Entrance() {
  return (
    <section id="entrance" className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-end justify-between">
        <div>
          <span className="text-xs font-bold tracking-widest text-primary-600">QUICK DOORS</span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            别让料凉了，选个入口进
          </h2>
        </div>
        <p className="hidden text-sm text-foreground-500 sm:block">三种方式，殊途同归进同一张讨论桌</p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
        {quickLinks.map((q) => {
          const a = accentMap[q.type];
          return (
            <a
              key={q.label}
              href={q.type === "primary" ? "#follow" : "#talk"}
              className="group relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-6 transition-all hover:-translate-y-1 hover:border-background-300 cursor-pointer"
            >
              <span className={`absolute left-0 top-0 h-full w-1 ${a.bar}`} aria-hidden="true"></span>
              <span className={`inline-flex h-12 w-12 items-center justify-center rounded-xl ${a.icon}`}>
                <i className={`${q.icon} text-2xl`}></i>
              </span>
              <p className="mt-4 text-lg font-black text-foreground-950">{q.label}</p>
              <p className="mt-1.5 text-sm text-foreground-600">{q.hint}</p>
              <span
                className={`mt-5 inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-bold ${a.btn}`}
              >
                直达入口
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </span>
            </a>
          );
        })}
      </div>
    </section>
  );
}